import { ChevronRight } from 'lucide-react';
import styles from './ClickableCard.module.css';
import patterns from '@/shared/ui/styles/patterns.module.css';

interface ClickableCardProps {
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
}

export function ClickableCard({ onClick, children, className }: ClickableCardProps) {
  const cls = [
    patterns.panelCompact,
    onClick && patterns.clickableCard,
    onClick && styles.clickable,
    className,
  ].filter(Boolean).join(' ');

  return (
    <div
      className={cls}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => e.key === 'Enter' && onClick() : undefined}
    >
      {onClick ? (
        <div className={styles.inner}>
          <div className={styles.content}>{children}</div>
          <ChevronRight size={16} className={styles.chevron} aria-hidden />
        </div>
      ) : children}
    </div>
  );
}
